import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <div className="sidebar">
        <h4 className="text-center py-3"><a className="navbar-brand" href="https://jdmember.tjdstore.in"><img className="logoimg" alt="Logo" width={186} src="https://jdmember.tjdstore.in/images/TJD-Digital-Logo.webp" /></a></h4>
        <ul>

                  <li className="nav-item">
                    <Link className="nav-link" to="/FetchSubscriptions">FetchSubscriptions</Link>

                  </li>

                </ul>
      </div>
    );
};

export default Header;
